<template lang="html">
    <b-modal v-model="showInfoModal" title="BundleID Rules"  @hide=" $emit('update:is-show', false)" hide-footer>
      <div>
        <strong>iOS</strong>  - numbers only without "id". <br>
        <strong>Android</strong> - enter the complete bundle (e.g., com.yourdomain.appname). <br>
      </div>
    </b-modal> 
</template>
<script>
    
export default {
    
    props: ['isShow'],
    data() {
        return {

        }
    },
    created(){

    },
    computed: {
        showInfoModal: {
            get: function() {
                return this.isShow
            },
            set: function() {

            }
        }
    },
    methods: {

    },    
}
</script>
<style scoped>

</style>